export enum TypeRoom {
  CROUSLessThan10 = 'Chambre Crous',
  LessThan10 = 'Chambre inférieure à 10 m²',
  Between11And40 = 'Chambre entre 11 m² et 40 m²',
  MoreThan40 = 'Chambre supérieure à 40 m²'
}

export enum SuperficieChambre {
  CROUSMoinsDe10m2 = 'CROUSMoinsDe10m2',
  MoinsDe10m2 = 'MoinsDe10m2',
  De11a40m2 = 'De11a40m2',
  PlusDe40m2 = 'PlusDe40m2'
}
